import {ConfigurationInterface} from "@api/models/interfaces/ConfigurationInterface";
import {DateTime} from "luxon";

export class Configuration implements ConfigurationInterface {
    authForm: string;
    availableLanguages: string;
    colorScheme: string;
    commonCss: string | null;
    createdAt: string | DateTime;
    dataSettings: string;
    id: string;
    isDeleted: boolean;
    isPublished: boolean;
    isTest: boolean;
    ownerId: number;
    publishedFor: Record<string, string>;
    rootActorId: string;
    servicesParams: Record<string, any>[];
    title: string;
    updatedAt: string | DateTime;
    updatedBy: number;

    constructor(data: ConfigurationInterface) {
        Object.assign(this, data);
    }
}
